export function ArrowUpIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.2364 5.70711C8.88492 6.09763 8.31508 6.09763 7.9636 5.70711L5 2.41421L2.0364 5.70711C1.68492 6.09763 1.11508 6.09763 0.763604 5.70711C0.412132 5.31658 0.412132 4.68342 0.763604 4.29289L4.3636 0.292893C4.71508 -0.0976311 5.28492 -0.0976311 5.6364 0.292893L9.2364 4.29289C9.58787 4.68342 9.58787 5.31658 9.2364 5.70711Z'
        fill='currentColor'
      />
    </svg>
  )
}
